import React from 'react';
import { Box, Typography } from '@mui/material';

interface SkillCategory {
  category: string;
  skills: string[];
}

export const Skills: React.FC = () => {
  const skillCategories: SkillCategory[] = [
    {
      category: 'Agents & LLMs',
      skills: ['Claude API', 'Claude Code', 'MCP', 'Tool Calling & Agents', 'Prompt Engineering', 'RAG', 'LLM Evaluation', 'Fine-tuning', 'LangChain', 'h2oGPTe / h2oGPT']
    },
    {
      category: 'On-device AI',
      skills: ['llama.cpp', 'ExecuTorch', 'LiteRT-LM', 'Ollama', 'Model Quantization', 'Mobile Benchmarking']
    },
    {
      category: 'Machine Learning',
      skills: ['XGBoost', 'Scikit-learn', 'TensorFlow/Keras', 'H2O Driverless AI', 'H2O-3', 'DataRobot']
    },
    {
      category: 'Data & Cloud',
      skills: ['AWS', 'Kubernetes', 'Apache Spark']
    },
    {
      category: 'Programming',
      skills: ['Python', 'TypeScript', 'React Native', 'React', 'Java', 'C++']
    },
    {
      category: 'Languages',
      skills: ['English', 'German', 'Persian']
    }
  ];

  return (
    <Box>
      <Typography variant="h4" gutterBottom sx={{
        mb: 3,
        color: '#FFFFFF',
        fontFamily: '"Inter", sans-serif'
      }}>
        Skills
      </Typography>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
        {skillCategories.map((category) => (
          <Box
            key={category.category}
            sx={{
              display: 'grid',
              gridTemplateColumns: { xs: '1fr', sm: '160px 1fr' },
              gap: { xs: 0.75, sm: 2 },
              alignItems: 'baseline',
            }}
          >
            <Typography sx={{
              color: '#00D4FF',
              fontFamily: '"JetBrains Mono", monospace',
              fontSize: '13px',
              fontWeight: 600,
            }}>
              {category.category}
            </Typography>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.75 }}>
              {category.skills.map((skill) => (
                <Box
                  key={skill}
                  component="span"
                  className="skill-chip"
                  sx={{
                    fontSize: '13px',
                    color: '#E0E6EA',
                    fontFamily: '"Inter", sans-serif',
                    px: 1.25,
                    py: 0.25,
                    borderRadius: '6px',
                    border: '1px solid rgba(0, 212, 255, 0.25)',
                    background: 'rgba(0, 212, 255, 0.06)',
                    '@media print': {
                      color: '#333333 !important',
                      border: '1px solid #cccccc !important',
                      background: 'transparent !important',
                      fontSize: '9pt !important',
                    }
                  }}
                >
                  {skill}
                </Box>
              ))}
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
}
